<div class="row m-0">
  <div class="col wb-ball">
    <div *ngIf="title"
      [class]="options.titleClass"
      [attr.aria-label]="title"
      class="custom-title">
      {{ title }}
      <i *ngIf="options.closeButton" (click)="remove()" class="rt-icon rt-cerrar pointer"></i>
    </div>
    <div *ngIf="message && options.enableHtml" role="alert" aria-live="polite"
      class="custom-message"
      [class]="options.messageClass">
      <span [innerHTML]="message"></span>  <a *ngIf="options.buttons && (options.buttons.id > -1) && (options.buttons.id !== null)" class="fw-bold text-white" (click)="action(options.buttons)"> {{'GLOBAL.SEEDETAIL' | translate}}</a>
    </div>
    <div *ngIf="message && !options.enableHtml" role="alert" aria-live="polite"
      class="custom-message"
      [class]="options.messageClass" [attr.aria-label]="message">
      {{ message }} <a *ngIf="options.buttons && (options.buttons.id > -1) && (options.buttons.id !== null)" class="fw-bold text-white" (click)="action(options.buttons)"> {{'GLOBAL.SEEDETAIL' | translate}}</a>
    </div>
  </div>
  <!-- <a class="btn btn-sm button" (click)="action($event)">
    {{options.chen}}
  </a> -->
  <!-- <div class="col-2 ps-0 text-end">
    <a *ngIf="options.closeButton" (click)="remove()" class="btn btn-sm toast-close-button">
      &times;
    </a>
  </div> -->
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
